module.exports = "https://static.wmbcdn.com/uniweb/images/6b6495ca9bf450096d3b46f6a173c546.svg";